import { useEffect } from 'react';
import _get from 'lodash/get';
import { useData, useStatus } from 'resift';
import { useDispatch } from 'react-redux';

// Interfaces
import Directory from 'types/Directory';

// Actions
import makeAllSourceMappingsFetch from 'store/mappings/actions/allSourceMappingsFetch';

interface Container {
  directory: Directory;
  sourceId: string;
}

export default function({ directory, sourceId }: Container) {
  const dispatch = useDispatch();
  const directoryId = _get(directory, ['id']);
  const allSourceMappingsFetch = makeAllSourceMappingsFetch(directoryId);

  useEffect(() => {
    dispatch(allSourceMappingsFetch(directory, sourceId)); // sourceId
  }, [sourceId]);

  const data = useData(allSourceMappingsFetch);
  const status = useStatus(allSourceMappingsFetch);

  return [data, status];
}
